/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_Auth_HeadersInputs */



/**
* | output |
* | --- |
* | "Headers (API key)" |
*
* @param {Mcp_Servers_Auth_HeadersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_auth_headers = /** @type {((inputs?: Mcp_Servers_Auth_HeadersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Auth_HeadersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Header (API-Schlüssel)")
	return /** @type {LocalizedString} */ ("Headers (API key)")
});